export type OrderNode = {
  path: string | string[];
  nestedPaths?: OrderNode[];
};

export type InputOrderSpec = OrderNode[];

export type PublicJobInfo = {
  leaderboardName: string;
  leaderboardConfigOverrideKey?: string;
  inputOrderSpec: InputOrderSpec;
};

const evalApiHostedModelInputOrderSpec: InputOrderSpec = [
  {
    path: 'model',
    nestedPaths: [
      {path: 'base_url'},
      {path: 'model_name'},
      {path: 'api_key_var'},
    ],
  },
  {
    path: 'tasks',
  },
  {
    path: 'hf_token',
  },
  {
    path: 'scorer_api_key',
  },
  {
    path: 'limit',
  },
  {
    path: 'create_leaderboard',
  },
];

const evalModelCheckpointInputOrderSpec: InputOrderSpec = [
  {
    path: 'artifact_path',
  },
  {
    path: 'tasks',
  },
  {
    path: 'hf_token',
  },
  {
    path: 'scorer_api_key',
  },
  {
    path: 'limit',
  },
  {
    path: 'create_leaderboard',
  },
];

export const PUBLIC_JOBS_INFO: Record<string, PublicJobInfo> = {
  'Evaluate API-hosted model': {
    leaderboardName: 'Inspect-AI-Leaderboard',
    leaderboardConfigOverrideKey: 'create_leaderboard',
    inputOrderSpec: evalApiHostedModelInputOrderSpec,
  },
  'Evaluate model checkpoint': {
    leaderboardName: 'Inspect-AI-Leaderboard',
    leaderboardConfigOverrideKey: 'create_leaderboard',
    inputOrderSpec: evalModelCheckpointInputOrderSpec,
  },
};

export const PUBLIC_JOBS = Object.keys(PUBLIC_JOBS_INFO);
